import apiClient from './apiClient';

const DEFAULT_ORG_ID = 1;

const dockService = {
  listDocks: async (orgId = DEFAULT_ORG_ID, opts = {}) => {
    const params = {};
    if (opts.siteId != null) params.siteId = opts.siteId;
    if (opts.limit != null) params.limit = opts.limit;
    if (opts.offset != null) params.offset = opts.offset;
    if (opts.sortBy != null) params.sortBy = opts.sortBy;
    if (opts.sortOrder != null) params.sortOrder = opts.sortOrder;

    const response = await apiClient.get(`/api/orgs/${orgId}/docks`, { params });
    return response.data;
  },

  searchDocks: async (orgId = DEFAULT_ORG_ID, opts = {}) => {
    const params = {};
    if (opts.q != null) params.q = opts.q;
    if (opts.siteId != null) params.siteId = opts.siteId;
    if (opts.limit != null) params.limit = opts.limit;
    if (opts.offset != null) params.offset = opts.offset;
    if (opts.sortBy != null) params.sortBy = opts.sortBy;
    if (opts.sortOrder != null) params.sortOrder = opts.sortOrder;

    const response = await apiClient.get(`/api/orgs/${orgId}/docks/search`, { params });
    return response.data;
  },

  getDock: async (orgId = DEFAULT_ORG_ID, dockId) => {
    const response = await apiClient.get(`/api/orgs/${orgId}/docks/${dockId}`);
    return response.data;
  },

  createDock: async (orgId = DEFAULT_ORG_ID, payload) => {
    const response = await apiClient.post(`/api/orgs/${orgId}/docks`, payload);
    return response.data;
  },

  patchDock: async (orgId = DEFAULT_ORG_ID, dockId, payload) => {
    const response = await apiClient.patch(`/api/orgs/${orgId}/docks/${dockId}`, payload);
    return response.data;
  },

  putDock: async (orgId = DEFAULT_ORG_ID, dockId, payload) => {
    const response = await apiClient.put(`/api/orgs/${orgId}/docks/${dockId}`, payload);
    return response.data;
  },

  deleteDock: async (orgId = DEFAULT_ORG_ID, dockId) => {
    await apiClient.delete(`/api/orgs/${orgId}/docks/${dockId}`);
  },
};

export default dockService;

